module.exports = __webpack_public_path__ + "static/img/scene3.4479a21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene/scene3.png
// module id = 1lgk
// module chunks = 1